import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { push } from 'react-router-redux';
import Tickets from './tickets';
import { getNSGlobalSettingsPageInfo } from '../../../redux/actions/settings';
// import { getNSTicketsInitiate } from '../../../redux/actions/ns/tickets';
import {
  putAMLSCommonApproveAndRejectTicket,
  getAMLSCommonTickets
} from '../../../redux/actions/common';

function mapStateToProps(state) {
  return {
    authentication: state.authentication,
    settings: state.settings,
    ticketsList: state.amlsCommon?.tickets?.list || null,
    approveAndReject: state.amlsCommon?.tickets?.approveAndReject || undefined
  };
}

function mapDispatchToProps(dispatch) {
  return {
    apiActions: bindActionCreators(
      {
        navigateTo: (path, param) => push(path, param),
        getNSGlobalSettingsPageInfo,
        getAMLSCommonTickets,
        putAMLSCommonApproveAndRejectTicket
      },
      dispatch
    )
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Tickets);
